import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ButtonGroup, Modal, Row, Col } from 'react-bootstrap';
import TeamInfo from "../team/TeamInfo";
import RiderInfo from "../team/RiderInfo";
import { InfoModalContext } from "./App";

function InfoModal(props) {

    const mounted = useRef(false);
    const { showInfo } = useContext(InfoModalContext);
    const handleClose = () => props.handleClose();
    const [objects, setObjects] = useState([]);
    const maxObjects = 8;

    function isSelectedObject(object) {
        return props.selectedObject.type === 'team' && 
            object.type === 'team' && 
            object.teamId === props.selectedObject.teamId 
            ||                
            props.selectedObject.type === 'rider' && 
            object.type === 'rider' && 
            object.riderId === props.selectedObject.riderId;
    }

    useEffect(() => {
        mounted.current = true;
    }, []);

    useEffect(() => {
        return () => mounted.current = false;
    }, []);

    useEffect(() => {
        if (props.selectedObject !== null) {
            // check if object is already loaded
            let objectsLocal = objects;
            if (objectsLocal.some(o => props.selectedObject.type === 'team' && o.type === 'team' && o.teamId === props.selectedObject.teamId ||
                props.selectedObject.type === 'rider' && o.type === 'rider' && o.riderId === props.selectedObject.riderId)) {
                // nothing to do
            }
            else {
                let newObject = props.selectedObject.type === 'team' ?
                    <TeamInfo key={'teamInfo' + props.selectedObject.teamId} teamId={props.selectedObject.teamId} />
                    :
                    <RiderInfo key={'riderInfo' + props.selectedObject.riderId} riderId={props.selectedObject.riderId} teamId={props.selectedObject.teamId} />;

                let newEntry = {
                    ...props.selectedObject,
                    name: props.selectedObject.name,
                    object: newObject
                }

                // attach in the back
                objectsLocal = objectsLocal.concat([newEntry]);
            }
            // cut first, if too many
            if (objectsLocal.length > maxObjects)
                objectsLocal = objectsLocal.slice(1, maxObjects + 1);

            setObjects(objectsLocal);
        }
    }, [props.selectedObject]);

    return <>
        {mounted.current && props.selectedObject ?
            <Modal key={'infoModal'}
                size="xl"
                show={props.show}
                onHide={handleClose} >
                <Modal.Body closeButton style={{ backgroundColor: 'rgba(222,233,244,1)' }}>
                    {objects.length > 0 ?
                        <>
                            <Row>
                                <Col>
                                    <ButtonGroup key={'infoSelection'}>
                                        {objects.map(o =>
                                            <Button className="py-0" key={'button' + o.type + o.riderId + o.teamId} size="sm" 
                                                variant={(isSelectedObject(o) ? '' : 'outline-') + 'primary'}
                                                onClick={isSelectedObject(o) ? null : () => showInfo(o.type, o.riderId, o.teamId, o.name, false)}>{o.name}</Button>
                                        )}
                                    </ButtonGroup>
                                </Col>
                            </Row>
                            {objects.some(o => isSelectedObject(o)) ?
                                <Row>
                                    <Col>
                                        {objects.find(o => isSelectedObject(o)).object}
                                    </Col>
                                </Row>
                                : null}
                        </>
                        : null}
                </Modal.Body>
                <Modal.Footer>
                    <Button className="py-0 m-0" variant="primary" onClick={handleClose}>{'Close'}</Button>
                </Modal.Footer>
            </Modal>
            : null}
    </>
}

export default InfoModal;